import type { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

/**
 * Catch-all 404 page. Also rendered by `RequirePermission` when the
 * current user lacks access to a guarded route — the URL is preserved so
 * the page is reachable from a direct link / bug report.
 */
export function NotFoundPage(): ReactElement {
  const { t } = useTranslation();
  return (
    <main
      role="alert"
      aria-labelledby="not-found-heading"
      className="mx-auto flex h-full max-w-xl flex-col justify-center gap-4 p-8"
    >
      <h1
        id="not-found-heading"
        className="text-2xl font-semibold tracking-tight text-card-foreground"
      >
        {t('routes.notFound.heading')}
      </h1>
      <p className="text-sm text-muted-foreground">
        {t('routes.notFound.message')}
      </p>
      <div>
        <Button asChild>
          <Link to="/my-cases">{t('routes.notFound.backToHome')}</Link>
        </Button>
      </div>
    </main>
  );
}
